import { useMutation, useQueryClient } from "react-query";
import { api } from "../../utils/api/api";

const createScholarshipApp = async (
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError,
  values
) => {
  try {
    const formattedData = { ...values, scholarshipId };

    const returnData = await api.post(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarship_application_protected_api/submitConsentForm`,
      formattedData,
      { token }
    );

    return returnData;
  } catch (err) {
    if (err?.httpStatus === 401) {
      handleInvalidToken();
    } else if (err?.httpStatus === 500) {
      handleAPIError();
    }
    throw new Error(err);
  }
};

export function useCreateScholarshipApp(
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError
) {
  const queryClient = useQueryClient();
  return useMutation(
    (values) => {
      return createScholarshipApp(
        scholarshipId,
        token,
        handleInvalidToken,
        handleAPIError,
        values
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("scholarshipApp");
      },
      retry: 3,
    }
  );
}
